import styled from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';

export const Meta = styled('p')<any>`
  line-height: 1.2;
  color: ${({ theme }) => theme.CasperGrey};
  margin: 0.25em 0 0;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : modularScale(-1))};

  > span:not(:first-child):before {
    content: ' • ';
    margin: 0 0.1em;
  }
`;
